import { __extends } from "tslib";
import { NodeMaterialBlock } from '../nodeMaterialBlock';
import { NodeMaterialBlockConnectionPointTypes } from '../Enums/nodeMaterialBlockConnectionPointTypes';
import { NodeMaterialBlockTargets } from '../Enums/nodeMaterialBlockTargets';
import { _TypeStore } from '../../../Misc/typeStore';
/**
 * Block used to get negative version of a value (i.e. x * -1)
 */
var NegateBlock = /** @class */ (function (_super) {
    __extends(NegateBlock, _super);
    /**
     * Creates a new NegateBlock
     * @param name defines the block name
     */
    function NegateBlock(name) {
        var _this = _super.call(this, name, NodeMaterialBlockTargets.Neutral) || this;
        _this.registerInput("value", NodeMaterialBlockConnectionPointTypes.AutoDetect);
        _this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);
        _this._outputs[0]._typeConnectionSource = _this._inputs[0];
        return _this;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */
    NegateBlock.prototype.getClassName = function () {
        return "NegateBlock";
    };
    Object.defineProperty(NegateBlock.prototype, "value", {
        /**
         * Gets the value input component
         */
        get: function () {
            return this._inputs[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NegateBlock.prototype, "output", {
        /**
         * Gets the output component
         */
        get: function () {
            return this._outputs[0];
        },
        enumerable: false,
        configurable: true
    });
    NegateBlock.prototype._buildBlock = function (state) {
        _super.prototype._buildBlock.call(this, state);
        var output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + (" = -1.0 * " + this.value.associatedVariableName + ";\r\n");
        return this;
    };
    return NegateBlock;
}(NodeMaterialBlock));
export { NegateBlock };
_TypeStore.RegisteredTypes["BABYLON.NegateBlock"] = NegateBlock;
//# sourceMappingURL=negateBlock.js.map